import { render, staticRenderFns } from "./JournalDetails.vue?vue&type=template&id=1f60fd76&scoped=true&"
import script from "./JournalDetails.vue?vue&type=script&lang=js&"
export * from "./JournalDetails.vue?vue&type=script&lang=js&"
import style0 from "./JournalDetails.vue?vue&type=style&index=0&id=1f60fd76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60fd76",
  null
  
)

export default component.exports